import {keyToCoords} from "../../coords/keyToCoords";
import {HexMath} from "../../HexMath";
import {ELVES_SHOOTING_RANGE} from "../../../configs/factions/elves";
import {hasObstacleInPath} from "../../gameState/shooting/calculateAvailableShootingCells";

/**
 * Рассчитывает доступные для стрельбы ячейки с вражескими отрядами
 * @param {Object} hexes - состояние гексов
 * @param {Array} units - все отряды
 * @param {Object} selectedUnit - выбранный отряд (катапульта)
 * @param pendingShootingActions
 * @param {Object} specialBuildings - специальные строения
 * @param {Object} buildingsDamage - уже применённые повреждения строений
 * @param fortressesUnderConstruction
 * @returns {Array} список hexKey доступных целей
 */
export const calculateAvailableShootingCellsForElves = (
  hexes,
  units,
  selectedUnit,
  pendingShootingActions,
  specialBuildings,
  buildingsDamage,
  fortressesUnderConstruction,
) => {
  // Проверяем не выстрелил ли отряд уже в этом этапе
  const alreadyShot = pendingShootingActions.some(
    action => action.shooterUnitId === selectedUnit.id
  );
  if (alreadyShot) {
    return [];
  }

  const hexMath = new HexMath(30, 'flat');

  const [selectedQ, selectedR] = keyToCoords(selectedUnit.hexKey);
  const shooterOwnerId = selectedUnit.ownerId;

  const targetCells = [];

  units.forEach(unit => {
    // Пропускаем отряды того же игрока
    if (unit.ownerId === shooterOwnerId) {
      return;
    }

    // Считаем уже полученный урон по отряду
    const existingDamage = pendingShootingActions
      .filter(action => action.targetUnitId === unit.id)
      .reduce((sum, action) => sum + action.damage, 0);

    // Пропускаем отряды которые уже будут уничтожены по суммарному урону
    if (unit.size <= existingDamage) {
      return;
    }

    const [targetQ, targetR] = keyToCoords(unit.hexKey);
    const distance = hexMath.hexDistance(selectedQ, selectedR, targetQ, targetR);

    // Проверяем что цель в радиусе и ячейка не заблокирована
    if (distance <= ELVES_SHOOTING_RANGE) {
      // Проверяем нет ли препятствий на прямой линии между стреляющим и целью
      if (!hasObstacleInPath(selectedUnit.hexKey, unit.hexKey, hexes, specialBuildings, pendingShootingActions, buildingsDamage, fortressesUnderConstruction)) {
        targetCells.push(unit.hexKey);
      }
    }
  });

  return targetCells;
};
